import React from "react";
import styles from "../../../style/components/chat/ChatView.module.css";
import images from "../../../utils/images";
import NoChatStyle from "./NoChatFound.module.css";

const NoChatFound = () => {
  return (
    <div className={styles.ChatViewMaincontentChatview}>
      <div className={NoChatStyle.noChatContainerSb}>
        <div className={NoChatStyle.noChatViewCenter}>
          <div className={NoChatStyle.noChatFoundImg}>
            <img src={images.notChatFound} alt="No conversations found" />
          </div>
          <h3 className={NoChatStyle.noChatTitle}>No Conversations Yet</h3>
          <p className={NoChatStyle.noChatFoundPara}>
            Start a new chat to begin fun and meaningful messaging, connect with
            others, and enjoy seamless conversations anytime!
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoChatFound;
